<template>
	<div class="settings">
		<v-layout row wrap>
			<v-flex md10>
				<filter-list class="mb-3" v-bind:value="filterValue" v-bind:loading="loading" v-on:selected-filter="selectedFilter" />
			</v-flex>
			<v-flex md2 class="text-xs-right">
				<button-create text="Tipo de limpieza" :href="createHref"></button-create>
			</v-flex>
		</v-layout>
		<table-run v-bind:columns="columns"
				   v-bind:rows="rows"
				   v-bind:include-delete="false"
				   v-bind:include-export-to-excel="false"
				   v-bind:include-options="true"
				   v-bind:include-switch="true"
				   v-bind:include-settings="true"
				   v-bind:include-delete-single="true"
				   v-bind:selectable="false"
				   v-on:on-sortable-event="columnSortableEvent"
				   v-on:on-search-event="searchByColumn"
				   v-on:on-change-state="changeState"
				   v-on:on-delete-event="deleteRow"
				   v-on:go-to-edit-page="goToEdit"
				   class="no-selectable-table">
			<template slot="rows" scope="props">
				<td>
					<room-status
						v-if="props.row.url_image && props.row.url_image !== preimage"
						v-bind:background-color="props.row.color_setting"
						v-bind:status-icon-img="props.row.url_image"
						v-bind:size="'small'"
						v-bind:name="props.row.code_setting"
						v-bind:room="props.row">
					</room-status>
					<room-status
						v-else
						v-bind:background-color="props.row.color_setting"
						v-bind:status-icon="props.row.icon_url"
						v-bind:size="'small'"
						v-bind:name="props.row.code_setting"
						v-bind:room="props.row">
					</room-status>
				</td>
				<td>{{props.row.name}}</td>
				<td>{{props.row.created_at}}</td>
			</template>    
		</table-run>
		<v-layout row wrap justify-end mt-3>
			<v-pagination
				:length="totalPages"
				:total-visible="pagesVisible"
				v-model="page"
				v-on:input="changePage">
			</v-pagination>
		</v-layout>
	</div>
</template>

<script>
import TableRun from 'table-run';
import mixin from '@/shared/mixins';
import settingResource from '@/resource/setting';
import helper from '@/shared/helper';
import RoomStatus from '@/components/shared/RoomStatus';
import ButtonCreate from '@/components/shared/ButtonCreate';
import FilterList from '@/components/shared/FilterList';

const helperData = helper.data();

function mounted() {
	this.resource = settingResource(this);
	this.loadData();
}

function columnSortableEvent({ id }) {
	const self = this;
	const newColumn = self.columns.filter(column => column.id === id);
	newColumn[0].isSortable = newColumn[0].isSortable.down ?
		{ down: false, up: true } : { down: true, up: false };
	self.columns = self.columns.map((columnSingle) => {
		const newColumnSingle = Object.assign({}, columnSingle);
		if (columnSingle.id !== newColumn[0].id) {
			newColumnSingle.isSortable = { down: true, up: false };
		}
		return newColumnSingle;
	});
	const sortGroupAsc = [
		{
			key: newColumn[0].code,
			direction: newColumn[0].isSortable.up ? 'ASC' : 'DSC',
		},
	];
	this.loadData(null, sortGroupAsc);
}

async function loadData(filterGroups, sortGroup, state) {
	const parameters = {
		limit: this.limit,
		page: this.page,
	};
	if (filterGroups) {
		parameters.filter_groups = filterGroups;
	}
	if (sortGroup) {
		parameters.sort = sortGroup;
	}
	const response = await this.resource.get(parameters);
	if (!state) {
		this.filterValue = 1;
	}
	this.totalPages = response.data.last_page;
	this.rows = response.data.data.map((row) => {
		const newRow = Object.assign({}, row);
		newRow.isSelected = false;
		newRow.isAdded = false;
		return newRow;
	});
	this.loading = false;
}

async function changeState({ id }) {
	const modelRow = this.rows.filter(row => row.id === id)[0];
	await this.resource.update({ id }, modelRow);
	this.loadData();
}

async function deleteRow({ id }) {
	await this.resource.delete({ id });
	this.loadData();
}

function goToEdit({ id }) {
	const editHref = { name: 'settings-config', params: { settingId: id } };
	this.$router.push(editHref);
}

function pagesVisible() {
	return this.totalPages < 5 ? this.totalPages : 5;
}

function searchByColumn(search) {
	const filterGroup = [
		{
			filters: [
				{
					key: 'name',
					value: search,
					operator: 'ct',
				},
			],
		},
	];
	this.loadData(filterGroup);
}

function selectedFilter(filter) {
	this.filterValue = filter.id;
	if (filter.id === 2) {
		const filterGroup = [
			{
				filters: [
					{
						key: 'flag_active',
						value: 1,
						operator: 'eq',
					},
				],
			},
		];
		this.loading = true;
		this.loadData(filterGroup, null, filter.id);
	} else if (filter.id === 3) {
		const filterGroup = [
			{
				filters: [
					{
						key: 'flag_active',
						value: 0,
						operator: 'eq',
					},
				],
			},
		];
		this.loading = true;
		this.loadData(filterGroup, null, filter.id);
	} else {
		this.loading = true;
		this.loadData();
	}
}

function changePage(value) {
	this.page = value;
	this.loadData();
}

export default {
	components: {
		ButtonCreate,
		FilterList,
		RoomStatus,
		TableRun,
	},
	computed: {
		pagesVisible,
	},
	data() {
		return {
			columns: [
				{ id: 1, name: 'Types of state', code: 'code_setting', isSortable: { down: true, up: false } },
				{ id: 2, name: 'Full name', code: 'name', isSortable: { down: true, up: false } },
				{ id: 3, name: 'Created date', code: 'created_at', isSortable: { down: true, up: false } },
			],
			createHref: { name: 'settings-new' },
			filterValue: 1,
			limit: 10,
			loading: false,
			page: 1,
			preimage: helperData.preimageUrl,
			resource: null,
			rows: [],
			totalPages: 5,
		};
	},
	name: 'settings',
	methods: {
		changePage,
		changeState,
		columnSortableEvent,
		deleteRow,
		goToEdit,
		loadData,
		searchByColumn,
		selectedFilter,
	},
	mixins: mixin,
	mounted,
};
</script>



// WEBPACK FOOTER //
// List.vue?5776adca